/**
 * localStorage helpers for persisting the Shopify cart id.
 *
 * All calls are guarded against SSR and storage-quota / privacy-mode failures.
 */

const KEY = "lmdr_cart_id";

function safeStorage(): Storage | null {
  try {
    if (typeof window === "undefined") return null;
    const ls = window.localStorage;
    // Probe write to detect Safari private mode / disabled storage.
    const probe = "__lmdr_probe__";
    ls.setItem(probe, "1");
    ls.removeItem(probe);
    return ls;
  } catch {
    return null;
  }
}

export function getCartId(): string | null {
  const ls = safeStorage();
  if (!ls) return null;
  const v = ls.getItem(KEY);
  return v && v.length > 0 ? v : null;
}

export function setCartId(id: string): void {
  const ls = safeStorage();
  if (!ls) return;
  try {
    ls.setItem(KEY, id);
  } catch {
    // Ignore quota errors — cart will be ephemeral.
  }
}

export function clearCartId(): void {
  const ls = safeStorage();
  if (!ls) return;
  try {
    ls.removeItem(KEY);
  } catch {
    // Ignore.
  }
}
